import * as Sentry from "@sentry/nextjs"
import { fetchApi } from "./api"
import { FetchError } from "./FetchErorr"
import { getApiToken } from "./getApiToken"
export type { GetResponseData } from "data/api"

const getDefaultHeaders = () => {
  const headers = new Headers()
  const token = getApiToken()

  if (token) {
    headers.append("Authorization", `Bearer ${token}`)
  }

  return headers
}

export type EndpointsGET = Parameters<typeof fetchApi<"get">>[1]

export const apiGET = async <T extends EndpointsGET>(endpoint: T) => {
  const res = await fetchApi("get", endpoint, {
    headers: getDefaultHeaders(),
  })

  if (!res.ok) {
    // Error for debugging
    const error = new Error(
      `Failed to fetch from "${endpoint}" - ${res.statusText}`
    )
    console.error(error)
    Sentry.captureException(error, {
      extra: {
        endpoint: endpoint,
      },
    })

    throw new FetchError(res.statusText, res.status, res)
  }

  const resData = await res.json()

  return resData
}
